import { IKnmActFamiliarizationNotificationsForm } from '../interfaces/IKnmActFamiliarizationNotificationsForm';

/**
 * Уведомление добавлено после последнего подписания акта/предписания: либо создано
 * на форме (isNew), либо сохранено с existedAtSigning === false (бэк проставляет
 * true всем уведомлениям в момент подписания)
 */
export const isFamiliarizationNotificationAddedAfterSigning = (
  notification: IKnmActFamiliarizationNotificationsForm | undefined,
): boolean => !!notification && (notification.isNew || notification.existedAtSigning !== true);
